import { FC, useEffect } from 'react';
import { observer } from 'mobx-react-lite';
import { Container, Grid } from '@material-ui/core';
import { useStyles } from './styles';
import { AppsTable } from 'components/Tables/AppsTable';
const Apps: FC = observer(() => {
  const classes = useStyles();

  useEffect(() => {
    document.title = 'EasyIdentity: App';
  }, []);

  return (
    <Container maxWidth='xl' className={classes.container}>
      <Grid className={classes.infoContainer} container alignItems='stretch' justify='space-between' spacing={3}>
        <AppsTable />
      </Grid>
    </Container>
  );
});

export default Apps;
